module.exports = __webpack_public_path__ + "static/img/social-media-icons.f429ae8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/social-media-icons.png
// module id = oBIz
// module chunks = 1